import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=53d91211&scoped=true"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=53d91211&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d91211",
  null
  
)

export default component.exports